/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Series_10_60Inputs */

const en_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series of 10, 1 hour lessons`)
};

const es_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie de 10 clases de 1 hora`)
};

const de_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie von 10 einstündigen Golfstunden`)
};

const zh_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 次 1 小时课程套餐`)
};

const ar_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلسلة من 10 دروس لمدة ساعة`)
};

const fr_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série de 10 leçons d'1 heure`)
};

const vi_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói 10 buổi học 1 giờ`)
};

const sw_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mfululizo wa masomo 10 ya saa 1`)
};

const th_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็ก 10 ครั้ง ครั้งละ 1 ชั่วโมง`)
};

const bs_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serija od 10 časova po 1 sat`)
};

const ja_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10回・1時間レッスン`)
};

const ko_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10회 1시간 레슨 시리즈`)
};

const pt_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacote de 10 aulas de 1 hora`)
};

const it_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie di 10 lezioni da 1 ora`)
};

const sv_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie med 10 lektioner à 1 timme`)
};

const nl_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reeks van 10 lessen van 1 uur`)
};

const da_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie med 10 lektioner à 1 time`)
};

const nb_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakke med 10 leksjoner à 1 time`)
};

const fi_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 opetuskerran sarja (1 tunti)`)
};

const pl_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seria 10 lekcji po 1 godzinie`)
};

const ru_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Серия из 10 уроков по 1 часу`)
};

const tr_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 adet 1 saatlik ders paketi`)
};

const hi_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 पाठों की श्रृंखला, प्रत्येक 1 घंटा`)
};

const id_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seri 10 pelajaran 1 jam`)
};

const ms_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siri 10 pelajaran, 1 jam`)
};

const cs_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série 10 lekcí po 1 hodině`)
};

const el_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σειρά 10 μαθημάτων της 1 ώρας`)
};

const he_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סדרה של 10 שיעורים של שעה אחת`)
};

const af_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reeks van 10 lesse van 1 uur`)
};

const hu_prices_label_series_10_60 = /** @type {(inputs: Prices_Label_Series_10_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 alkalmas, 1 órás bérlet`)
};

/**
* | output |
* | --- |
* | "Series of 10, 1 hour lessons" |
*
* @param {Prices_Label_Series_10_60Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_series_10_60 = /** @type {((inputs?: Prices_Label_Series_10_60Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Series_10_60Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_series_10_60(inputs)
	if (locale === "de") return de_prices_label_series_10_60(inputs)
	if (locale === "zh") return zh_prices_label_series_10_60(inputs)
	if (locale === "ar") return ar_prices_label_series_10_60(inputs)
	if (locale === "fr") return fr_prices_label_series_10_60(inputs)
	if (locale === "vi") return vi_prices_label_series_10_60(inputs)
	if (locale === "sw") return sw_prices_label_series_10_60(inputs)
	if (locale === "th") return th_prices_label_series_10_60(inputs)
	if (locale === "bs") return bs_prices_label_series_10_60(inputs)
	if (locale === "ja") return ja_prices_label_series_10_60(inputs)
	if (locale === "ko") return ko_prices_label_series_10_60(inputs)
	if (locale === "pt") return pt_prices_label_series_10_60(inputs)
	if (locale === "it") return it_prices_label_series_10_60(inputs)
	if (locale === "sv") return sv_prices_label_series_10_60(inputs)
	if (locale === "nl") return nl_prices_label_series_10_60(inputs)
	if (locale === "da") return da_prices_label_series_10_60(inputs)
	if (locale === "nb") return nb_prices_label_series_10_60(inputs)
	if (locale === "fi") return fi_prices_label_series_10_60(inputs)
	if (locale === "pl") return pl_prices_label_series_10_60(inputs)
	if (locale === "ru") return ru_prices_label_series_10_60(inputs)
	if (locale === "tr") return tr_prices_label_series_10_60(inputs)
	if (locale === "hi") return hi_prices_label_series_10_60(inputs)
	if (locale === "id") return id_prices_label_series_10_60(inputs)
	if (locale === "ms") return ms_prices_label_series_10_60(inputs)
	if (locale === "cs") return cs_prices_label_series_10_60(inputs)
	if (locale === "el") return el_prices_label_series_10_60(inputs)
	if (locale === "he") return he_prices_label_series_10_60(inputs)
	if (locale === "af") return af_prices_label_series_10_60(inputs)
	if (locale === "hu") return hu_prices_label_series_10_60(inputs)
	return en_prices_label_series_10_60(inputs)
});